import {
    DatiqGraphAxisDateTypes,
    DatiqGraphAxisNumberTypes,
} from '../../models';
import * as am5 from '@amcharts/amcharts5';

export const datiqAmcharts5DateFormats = {
    [DatiqGraphAxisDateTypes.Daily]: 'mm/dd',
    [DatiqGraphAxisDateTypes.Weekly]: 'mm/dd',
    [DatiqGraphAxisDateTypes.Monthly]: `mmm \'yy`,
};

export const datiqAmCharts5NumberFormats = {
    [DatiqGraphAxisNumberTypes.Currency]: `$#,###.##|-$#,###.##s`,
    [DatiqGraphAxisNumberTypes.CurrencyThousand]: '$#a|-$#as',
    [DatiqGraphAxisNumberTypes.CurrencyDollar]: `$##.00`,
    [DatiqGraphAxisNumberTypes.Percent]: `#'%'`,
    [DatiqGraphAxisNumberTypes.Thousand]: '#a',
    [DatiqGraphAxisNumberTypes.Millage]: "#,###'mi'",
};

export const datiqAmcharts5SetColor = (hexColor: string): am5.Color => {
    return !!hexColor?.length ? am5.Color.fromString(hexColor) : null;
};
